import { render } from "./MoreActionOptions.vue?vue&type=template&id=5bef4264"
import script from "./MoreActionOptions.vue?vue&type=script&lang=js"
export * from "./MoreActionOptions.vue?vue&type=script&lang=js"
script.render = render

export default script